import AsyncReactSelect from 'react-select/async';

import cssClasses from 'components/select/select.module.scss';
import { Group, GroupHeading, Option } from 'components/select/shared';
import { AsyncSelectProps } from 'types/components/select';

function AsyncSelect<IsMulti extends boolean = false, Option = unknown>(props: AsyncSelectProps<IsMulti, Option>) {
  const { components } = props;

  return (
    <AsyncReactSelect
      {...props}
      cacheOptions
      className={cssClasses.select}
      classNamePrefix="select"
      components={{
        Group,
        GroupHeading,
        Option,
        ...components,
      }}
      defaultOptions
    />
  );
}

export default AsyncSelect;
